import api from "./api";

export const getShareData = async () => {
    try {
        const response = await api.get('/get-shares');
        if (response.data) {
            return response.data.data;
        }
    } catch (error) {
        console.error("shares error:", error);
        throw error;
    }
};

export const getMarketData = async (mode = 'FULL', exchangeTokens = []) => {

    try {
        const response = await api.post('/market-data', {
            mode: mode,
            exchangeTokens: exchangeTokens,
        });

        if (response.data) {
            return response.data;
        } else {
            throw new Error('Unexpected response format');
        }
    } catch (error) {
        if (error.response) {
            console.error('Error fetching market data:', error.response.data);
            throw new Error(`Server error: ${error.response.data.error || 'Unknown error'}`);
        } else if (error.request) {
            console.error('Network error:', error.request);
            throw new Error('Network error: Unable to reach the server');
        } else {
            console.error('Error:', error.message);
            throw error;
        }
    }
};

export const getAllMarketData = async (exchange = '', client_id) => {
    try {
        const response = await api.post('/all-market-data', {
            exchange: exchange,
            client_id: client_id,
        });
        if (response.data) {
            return response.data;

        }
        else {
            throw new Error('Unexpected response format');
        }
    } catch (error) {
    }
};

export const getTopGainersLosersData = async () => {
    try {
        const response = await api.post('/top-gainers-losers-data');

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching Top Gainers:", error.response ? error.response.data : error.message);
        throw error;
    }
};

export const listOrders = async () => {
    try {
        const response = await api.post('/list-orders');

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching orders:", error.response ? error.response.data : error.message);
        throw error;
    }
};

export const listLimitOrders = async () => {
    try {
        const response = await api.post('/limit-orders');

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching orders:", error.response ? error.response.data : error.message);
        throw error;
    }
};

export const placeOrder = async (script_id, price, lotSize, qty, exchange_id, buttonType, order_type, expiry, token, orderId, squareOff, circuit_low, circuit_high, high, low, limit_order_id, marketprice) => {

    const orderPayload = {
        script_id: script_id,
        price: price,
        lots: lotSize,
        qty: Number(qty),
        ip_address: '::12',
        exchange_id: exchange_id,
        type: buttonType,
        order_type: order_type,
        expiry: expiry,
        token: token,
        square_off_order_id: orderId,
        square_off: squareOff,
        circuit_low,
        circuit_high,
        high,
        low,
        limit_order_id: limit_order_id ? limit_order_id : null,
        marketprice
    };

    try {

        const response = await api.post('/place-order', orderPayload);
        return response.data;
    } catch (error) {
        console.error("Error placing order:", error.response?.data || error.message);
        throw error;
    }
};

export const currentPosition = async () => {
    try {
        const response = await api.post('/currentposition');

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        throw error;
    }
};

export const bookedplposition = async () => {
    try {
        const response = await api.post('/bookedplposition');

        if (response.data) {
            return response.data;
        }

    } catch (error) {
        throw error;
    }
};

export const clientPositionsGet = async () => {
    try {
        const response = await api.post('/client/client-position');

        if (response.data) {
            return response.data;
        }

    } catch (error) {
        throw error;
    }
};

export const closeAllOrders = async () => {
    try {
        const response = await api.post('/client/close-all-orders');

        if (response.data) {
            return response.data;
        }

    } catch (error) {
        throw error;
    }
};

export const deleteWatchlist = async (watchlistId) => {
    try {
        const response = await api.post('/client/delete-watchlist', { watchlist_id: watchlistId });

        if (response.data) {
            return response.data;
        }
        else {
            throw new Error('Unexpected response format');
        }
    } catch (error) {
        throw error;
    }
};

export const getRejectionLogs = async () => {
    try {
        const response = await api.get('client/list-rejection-logs');

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching rejection logs:", error.response ? error.response.data : error.message);
        throw error;
    }
};
export const getGetBills = async () => {
    try {
        const response = await api.post('get-client-bill');

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching Bill:", error.response ? error.response.data : error.message);
        throw error;
    }
};

export const placeOrderformportfolio = async (script_id, price, lotSize, qty, exchange_id, buttonType, order_type, expiry, token, orderId, squareOff, circuit_low, circuit_high, high, low, limit_order_id, client_id, script_name, marketprice) => {

    const orderPayload = {
        script_id: script_id,
        price: price,
        lots: lotSize,
        qty: qty,
        ip_address: '::12',
        exchange_id: exchange_id,
        type: buttonType,
        order_type: order_type,
        expiry: expiry,
        token: token,
        square_off_order_id: orderId,
        square_off: squareOff,
        circuit_low,
        circuit_high,
        high,
        low,
        limit_order_id: limit_order_id ? limit_order_id : null,
        client_id,
        script_name,
        marketprice,
        from_portfolio: 'portfolio'
    };

    try {
        const response = await api.post('/place-order', orderPayload);
        return response.data;
    } catch (error) {
        console.error("Error placing order:", error.response?.data || error.message);
        throw error;
    }
};


export const deleteLimitOrder = async (limitOrderId) => {
    try {
        const response = await api.post('/client/delete-limitorders', { limit_order_id: limitOrderId });

        if (response.data) {
            return response.data;
        }
        else {
            throw new Error('Unexpected response format');
        }
    } catch (error) {
        throw error;
    }
};

export const getmarginValues = async (scriptId) => {
    try {
        const response = await api.post('/client/margin-value', { script_id: scriptId });

        if (response.data) {
            return response.data;
        }
        else {
            throw new Error('Unexpected response format');
        }
    } catch (error) {
        throw error;
    }
};